import React, { useState, useEffect, useCallback } from "react";
import { SVGIcons, ImgIcons, VirsionCheck } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";

var SVGIcon = "";
var ImageData = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

export function Layout27(props) {
  const [bgDesktop, setbgDesktop] = useState("");
  const [bgMobile, setbgMobile] = useState("");
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [handleTimeout]);

  useEffect(() => {
    let imageDesktop = props.bgGoldenDesk ? props.bgGoldenDesk : props.bgSilverDesk;
    let imageMobile = props.bgGoldenMob ? props.bgGoldenMob : props.bgSilverMob;
    setbgDesktop(imageDesktop);
    setbgMobile(imageMobile);
  }, []);

  return (
    <>
      <section className="mb-0">
        <div
          className="DocuOri"
          style={{
            background: isMobile ? `url(${bgMobile})` : `url(${bgDesktop})`,
          }}
        >
          {/* {showShimmer ? (
            <div className="line linedesk linehead" />
          ) : (
            <>    </>
            )} */}
          <div className="DocuOri-layout">
            {/* <img src={data.docubay_original_url} alt="original" /> */}
            <img src={props.originalLogo} alt="original" />
            {/* <img src={ImageData["Docubay_Originals_01_400x40-01.png"]} alt="originalIMG"/> */}
          </div>
          <Swiper
            navigation={{
              prevEl: ".slick-prev",
              nextEl: ".slick-next",
            }}
            slidesPerView={1}
            pagination={true}
            breakpoints={{
              650: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1,
              },
              850: {
                slidesPerView: 1,
              },
            }}
            modules={[FreeMode, Pagination, Navigation]}
            className="original-slider"
          >
            <div className="side-overlay-L dD-block"></div>
            <button className="slick-prev slick-arrow" type="button" />
            {props.Layout1.map((data, index) => {
              var video_url_4k = "";
              var Age = data.age_restriction;

              if (data.video_4k) {
                video_url_4k = (
                  <>
                    <div className="nBay nBay2">{data.video_4k}</div>
                  </>
                );
              } else {
                video_url_4k = (
                  <>
                    <div className="nBay nBay2">{data.video_hd}</div>
                  </>
                );
              }

              if (data.awards && data.awards != null) {
                var awards = (
                  <>
                    <span className="dot" />
                    &nbsp;&nbsp;
                    <img src="img/svg/wincup.svg" /> Award Winning
                  </>
                );
              }

              if (data.release_date) {
                var releaseDate =
                  <>
                    <div>{data.release_date}</div>&nbsp;
                  </>
              }

              return (
                <SwiperSlide key={index}>
                  {/* {showShimmer ? (
                    <div className="shimmerOriginal">
                      <img src={ImageData["placeholder3.png"]} alt="shimmer" className="shimmer" />
                      <div className="rightOriginal">
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                        <div className="linebtn" />
                      </div>
                    </div>
                  ) : (
                    <>   </>
                    )} */}
                  <div className="tempOriginal">
                    <div className="DocOriginal">
                      <Link to={"/" + data.slug}>
                        <img src={data.banner_image.medium} alt="DocBuster" />
                        <img src={SVGIcon["play-2.svg"]} className="docbus-btn" />
                      </Link>
                    </div>
                    <div className="tempOriginal-right">
                      <div className="tempOriginal-award">
                        <div className="tempOriginal-main">
                          {releaseDate}
                          &nbsp;
                          {data.content_type == "SHOW" ? null :
                            <>
                              <span className="dot" />&nbsp;&nbsp;
                              <div>{data.duration / 60} Mins</div>&nbsp;&nbsp;
                            </>}
                          <div className="dD-block">
                            <span className="dot" />&nbsp;&nbsp;
                            {data.keywords.split(",")[0]}
                          </div>
                        </div>
                        <div className="right-text dD-none">{data.keywords.split(",")[0]} </div>
                      </div>
                      <div className="tempOriginal-inn">
                        <div className="nBay nBay2">
                          {data.content_category} {Age}
                        </div>
                        &nbsp;
                        <div className="nBay nBay4">{data.genres.split(",")}</div>
                        &nbsp;
                        {video_url_4k}
                      </div>
                      <div className="tempOriginal-text">
                        <h2>{data.title}</h2>
                        <p>{data.short_description}</p>
                      </div>
                      <Link to={"/" + data.slug}>
                        <button
                          type="submit"
                          id="sendEnquiryBtn"
                          className="watch-DocuOriginal"
                        >
                          WATCH NOW
                        </button>
                      </Link>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
            <div className="side-overlay-R dD-block"></div>
            <button
              className="slick-next slick-arrow"
              type="button"
              aria-label="Next"
            />
          </Swiper>
        </div>
      </section>
    </>
  );
}

export default Layout27;
